import React from 'react';
import { isRoleAdmin } from 'src/utils/check-user-is-admin';
import Page403 from 'src/pages/403';

export default function AdminGuard({ children }: { children: React.ReactNode }) {
  return isRoleAdmin() ? <>{children}</> : <Page403 />;
}
